import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { IFormProfile } from 'legacy/lut/classes/models/IFormProfile'
import { SelectPartnerTable } from 'legacy/lut/components/widgets/public/onboarding/requestsInfo/requestTypes/SelectPartnerTable'
import React, { useEffect, useState } from 'react'

import { Button } from 'core-components/library/button'
import { Input } from 'core-components/library/inputs'
import { ModalDialog } from 'core-components/library/modalDialog'

import styles from './ContactRelinking.module.scss'

interface IContactRelinking {
  entryIdItem: IFormProfile | DataModel
  onChangeField: (fieldName: string, value: string | number | boolean, silent?: boolean) => void
  checkEmailValidation: (withUniq?: boolean) => void
  readOnly: boolean
  newPartnerId?: string
}

export const ContactRelinking = (props: IContactRelinking) => {
  const { entryIdItem, readOnly, newPartnerId, onChangeField, checkEmailValidation } = props
  const [isOpenSelectPartners, setOpenSelectPartners] = useState(false)
  const isDisabled = readOnly || entryIdItem.get('WorkflowStatus') === 'WIP'

  useEffect(() => {
    if (newPartnerId) {
      onChangeField('NewPartnerID', newPartnerId)
    }
  }, [newPartnerId, onChangeField])

  const dialogSelectPartners = () => {
    return (
      <ModalDialog
        show={isOpenSelectPartners}
        size={'xl'}
        onClose={() => setOpenSelectPartners(false)}
        content={SelectPartnerTable}
        contentProps={{
          onboardingTable: true,
          disableEditAction: true,
          sourceKey: 'ContactRelinking',
          onSelect: (item: any) => {
            if (item && item.PartnerID) {
              onChangeField('NewPartnerID', item.PartnerID)
            }
            setOpenSelectPartners(false)
          },
        }}
      />
    )
  }

  return (
    <div className={styles.root}>
      <Input
        id="cmp-firstname"
        label="First Name"
        margin={'md'}
        disabled={isDisabled}
        value={entryIdItem.get('FirstName') || ''}
        onChange={(val) => onChangeField('FirstName', val)}
      />
      <Input
        id="cmp-lastname"
        label="Last Name"
        margin={'md'}
        disabled={isDisabled}
        value={entryIdItem.get('LastName') || ''}
        onChange={(val) => onChangeField('LastName', val)}
      />
      <Input
        id="cmp-email"
        label="Email"
        margin={'md'}
        disabled={isDisabled}
        value={entryIdItem.get('Email') || ''}
        onChange={async (val) => {
          onChangeField('Email', val)
          await checkEmailValidation()
        }}
      />
      <Input
        id="cmp-partnerId"
        label="Current Partner"
        margin={'md'}
        disabled={true}
        value={
          newPartnerId ? entryIdItem.get('NewPartnerID') || '' : entryIdItem.get('PartnerID') || ''
        }
      />
      <Input
        id="cmp-partnerId"
        label="New Partner"
        margin={'md'}
        disabled={true}
        value={
          newPartnerId ? entryIdItem.get('PartnerID') || '' : entryIdItem.get('NewPartnerID') || ''
        }
      />
      <Input
        placeholder={'Add comment...'}
        margin={'md'}
        disabled={!entryIdItem.get('NewPartnerID') || isDisabled}
        value={entryIdItem.get('RelinkingComment') || ''}
        onChange={(value) => onChangeField('RelinkingComment', value)}
      />
      {!newPartnerId && (
        <Button disabled={isDisabled} onClick={() => setOpenSelectPartners(true)}>
          Select new partner
        </Button>
      )}
      {isOpenSelectPartners ? dialogSelectPartners() : null}
    </div>
  )
}
